import { useLayoutEffect, useState } from "react"

const useElementHeight = ref => {
  const [height, setHeight] = useState(0)

  useLayoutEffect(() => {
    let frameId = null
    let observer = null
    let resizeHandler = null

    const attachObserver = () => {
      const element = ref.current

      if (!element) {
        frameId = window.requestAnimationFrame(attachObserver)
        return
      }

      setHeight(element.getBoundingClientRect().height)

      if (typeof ResizeObserver !== "undefined") {
        observer = new ResizeObserver(entries => {
          const nextHeight = entries[0]?.contentRect?.height || 0
          setHeight(nextHeight)
        })

        observer.observe(element)
        return
      }

      const updateHeight = () => {
        frameId = null
        setHeight(element.getBoundingClientRect().height)
      }

      const requestHeightUpdate = () => {
        if (frameId === null) {
          frameId = window.requestAnimationFrame(updateHeight)
        }
      }

      resizeHandler = requestHeightUpdate
      requestHeightUpdate()
      window.addEventListener("resize", resizeHandler, { passive: true })
    }

    attachObserver()

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId)
      }
      if (observer) {
        observer.disconnect()
      }
      if (resizeHandler) {
        window.removeEventListener("resize", resizeHandler)
      }
    }
  }, [ref])

  return height
}

export default useElementHeight
